VjsAdmin.DatesForm = (function () {
    const init = function () {
        $('.date-delete').on('click', 'a', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');

            $(this).attr('href', '#');
            $('body').css('cursor', 'wait');
            $('.app').addClass('light-blur');
            $('#ajax-progress-indicator').fadeIn();

            $.post(href, null, () => {
                window.location.reload();
            }).fail(function () {
                $(this).attr('href', href);
                $('.app').removeClass('light-blur');
                $('body').css('cursor', 'default');
                $('#ajax-progress-indicator').fadeOut();
            });
        });

        VjsAdmin.initDateRangePickers($('#dates-form'));
    };

    return {
        init,
    };
}());
